/* =============================================================================
 * Delta Clothing — cart store
 *
 * Ports the `__dlc_bag` SWR loader + bag-count + cross-tab sync logic from
 * new-ella's sections/main-cart.liquid and assets/custom.js into a standalone
 * bundle Stockmart can load. Hard contract this module preserves:
 *
 *   - sessionStorage key:   __fastbag_cache_v2
 *   - global:               window.__dlc_bag (load/getCache/setCache/readSS/postJSON)
 *   - global:               window.__dlc_wipeLocalCart
 *   - localStorage key:     bag_count_qty:{customerId}
 *   - event:                dlc:cart-changed
 *
 * Depends on window.B2B (see b2b-config.js).
 * =============================================================================*/
(function () {
  if (!window.B2B || window.__dlc_bag) return;

  var B2B = window.B2B;
  var SSKEY = '__fastbag_cache_v2';
  var TTL = 2000;

  var customerId = B2B.getCustomerId();
  var customerGid = B2B.getCustomerGid();

  function postJSON(obj) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(obj)
    };
  }

  function sumQty(lines) {
    return (lines || []).reduce(function (total, ln) {
      var q = parseInt(ln && ln.quantity, 10);
      return total + (isNaN(q) ? 0 : q);
    }, 0);
  }

  function saveSS(data) {
    try {
      sessionStorage.setItem(SSKEY, JSON.stringify({
        at: Date.now(),
        customer: customerId || '',
        data: data || []
      }));
    } catch (e) {}
  }

  function readSS() {
    try {
      var raw = sessionStorage.getItem(SSKEY);
      if (!raw) return null;
      var o = JSON.parse(raw) || null;
      if (!o) return null;
      if (o.customer !== (customerId || '')) return null;
      return o;
    } catch (e) { return null; }
  }

  var cache = null;
  var ts = 0;
  var inflight = null;
  var cacheVersion = 0;

  function writeCache(data) {
    cache = Array.isArray(data) ? data : [];
    ts = Date.now();
    cacheVersion += 1;
    saveSS(cache);
    return cache;
  }

  function load(force) {
    var now = Date.now();
    var versionAtStart = cacheVersion;
    if (!force && cache && (now - ts) < TTL) return Promise.resolve(cache);
    if (inflight) return inflight;
    if (!customerGid) {
      cache = cache || [];
      return Promise.resolve(cache);
    }

    inflight = fetch(B2B.endpoints.bag, Object.assign(postJSON({ customer_id: customerGid }), { cache: 'no-store' }))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var arr = Array.isArray(d) ? d : [];
        var cachedDraftId = cache && cache[0] && cache[0].draft_id;
        var fetchedDraftId = arr && arr[0] && arr[0].draft_id;

        if (!fetchedDraftId) {
          inflight = null;
          return writeCache(arr);
        }

        // Same draft, server shows fewer items than us within a 1s
        // optimistic window: assume our in-flight local mutation is the
        // truth so a slow server response doesn't undo what the user
        // just did.
        var optimistic = cachedDraftId
          && fetchedDraftId === cachedDraftId
          && cache
          && (Date.now() - ts) < 1000
          && sumQty(arr) < sumQty(cache);
        if (optimistic) {
          inflight = null;
          return cache || [];
        }

        if (versionAtStart !== cacheVersion) {
          inflight = null;
          return cache || [];
        }

        inflight = null;
        return writeCache(arr);
      })
      .catch(function () { inflight = null; return (cache = cache || []); });

    return inflight;
  }

  (function bootstrap() {
    var ss = readSS();
    if (ss && Array.isArray(ss.data)) {
      cache = ss.data;
      ts = ss.at || 0;
    }
  })();

  function wipeLocalCart() {
    try { sessionStorage.removeItem(SSKEY); } catch (e) {}
    cache = [];
    ts = 0;
    cacheVersion += 1;
    try {
      if (customerId) localStorage.setItem('bag_count_qty:' + customerId, '0');
    } catch (e) {}
    var badge = document.querySelector('[data-cart-count],[data-fastbag-count]');
    if (badge) badge.textContent = '0';
  }

  function setBagCountFromResponse(resp) {
    try {
      if (!customerId) return;
      var qty = (resp && (resp.count || resp.count === 0)) ? Number(resp.count) : NaN;
      if (isNaN(qty)) return;
      document.querySelectorAll('[data-cart-count],[data-fastbag-count]').forEach(function (b) {
        b.textContent = String(qty);
      });
      try { localStorage.setItem('bag_count_qty:' + customerId, String(qty)); } catch (e) {}
    } catch (e) {}
  }

  /* ------- header badge sync ------- */
  function paintBadgeFromLocalCache() {
    if (!customerId) return;
    try {
      var v = localStorage.getItem('bag_count_qty:' + customerId);
      if (v != null) {
        document.querySelectorAll('[data-cart-count],[data-fastbag-count]').forEach(function (b) {
          b.textContent = v;
        });
      }
    } catch (e) {}
  }

  function refreshBagCount() {
    if (!customerGid) return;
    B2B.postJSON(B2B.endpoints.bagCount, { customer_id: customerGid })
      .then(function (data) {
        if (!data) return;
        var qty = Number(data.count || 0);
        try { localStorage.setItem('bag_count_qty:' + customerId, String(qty)); } catch (e) {}
        document.querySelectorAll('[data-cart-count],[data-fastbag-count]').forEach(function (b) {
          b.textContent = String(qty);
        });
      })
      .catch(function () { /* leave whatever cache already painted */ });
  }

  // Cross-tab sync — if another tab updates the cached count, repaint here.
  window.addEventListener('storage', function (e) {
    if (!customerId) return;
    if (e.key === ('bag_count_qty:' + customerId) && e.newValue != null) {
      document.querySelectorAll('[data-cart-count],[data-fastbag-count]').forEach(function (b) {
        b.textContent = e.newValue;
      });
    }
  });

  // After a /coupon /remove /clear, the bridge dispatches dlc:cart-changed —
  // refresh /bag once more (force) so any sessionStorage cache reflects truth.
  window.addEventListener('dlc:cart-changed', function () {
    try { load(true); } catch (e) {}
    try { refreshBagCount(); } catch (e) {}
  });

  // Catch the "I just came back from Shopify checkout" transition. If the
  // draft has just been completed the server-side cart is empty and the
  // sessionStorage cache must be wiped before another tab repaints stale lines.
  function checkPostCheckoutReturn() {
    try {
      var ref = String(document.referrer || '');
      var fromCheckout = /\/(checkout|checkouts|orders|thank[_-]?you)/i.test(ref);
      var hasOrderParam = /[?&](order_id|checkout|order_number|fulfillment_status)=/i.test(window.location.search || '');
      if (!fromCheckout && !hasOrderParam) return;
      load(true).then(function (lines) {
        if (!Array.isArray(lines) || lines.length === 0) {
          wipeLocalCart();
          try { window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: { count: 0, source: 'post-checkout-return' } })); } catch (e) {}
        }
      });
    } catch (e) {}
  }

  window.__dlc_bag = {
    load: load,
    getCache: function () { return cache; },
    setCache: writeCache,
    readSS: readSS,
    postJSON: postJSON
  };
  window.__dlc_wipeLocalCart = wipeLocalCart;
  window.setBagCountFromResponse = setBagCountFromResponse;
  window.func_bag_count = refreshBagCount;

  function init() {
    paintBadgeFromLocalCache();
    refreshBagCount();
    checkPostCheckoutReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    setTimeout(init, 0);
  }
})();
